<!-- Add 40px margin to the left of the sign-in component because Clerk component is incorrectly aligned -->
<div class="w-full max-w-md sm:ml-[40px]">
  <clerk-sign-in [props]="signInProps" />
</div>
